import Swal from 'sweetalert2'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { showAlertLoading, showError } from '../../../../../../../_metronic/helpers'
import { Button, TableSelectionBar, useToast } from '../../../../../../components'
import { generateAsoLote } from '../../core/_request'

const asos = (n: number) => `${n} ${n === 1 ? 'ASO' : 'ASOs'}`

export const GenerateAsoListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  const generateAsos = async () => {
    showAlertLoading()
    const { gerados, erros, primeiroErro } = await generateAsoLote(selected)
    Swal.close()

    if (gerados === 0) {
      // Nada gerado: mostra o motivo (normalmente pendência no atendimento).
      showError(primeiroErro)
    } else if (erros > 0) {
      showToast({
        variant: 'warning',
        title: `${asos(gerados)} gerado(s), ${asos(erros)} com erro.`,
        description: 'Os que falharam continuam na lista. Use “Editar” para ver as pendências.',
      })
    } else {
      showToast({ variant: 'success', title: `${asos(gerados)} gerado(s).` })
    }

    clearSelected()
    refetch()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <Button className='btn-primary' onClick={generateAsos}>
        {count === 1 ? 'Gerar ASO' : `Gerar ${count} ASOs`}
      </Button>
    </TableSelectionBar>
  )
}
